import { render, staticRenderFns } from "./QuotaAmount.vue?vue&type=template&id=e6ac142c&"
import script from "./QuotaAmount.vue?vue&type=script&lang=js&"
export * from "./QuotaAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports